<ng-template #rt let-r="result" let-t="term">
  {{ r.destination }} ({{ r.gateway.toUpperCase() }})
</ng-template>
@if (
  {
    terminals: searchParameters.terminals | async,
    isArrivalLoading: isArrivalLoading | async
  };
  as data
) {
  <div class="parking-search-container">
    @if (searchParameters?.clonedBasketItemDetails?.name) {
      <div>
        <app-cloned-details
          [name]="searchParameters?.clonedBasketItemDetails?.name"
        ></app-cloned-details>
      </div>
    }
    <div class="half-container">
      <div class="half-block">
        <div class="half-container">
          <div class="half-block">
            <label
              class="header-label"
              id="terminallabel"
              i18n="@@pnlSearchCountry"
              for="lounge-select-country"
              >Country</label
            >
            <select
              [(ngModel)]="searchParameters.countryCode"
              appSelect
              class="select-box-right terminals"
              id="lounge-select-country"
            >
              @for (country of searchParameters.countriesWithLounges; track country) {
                <option [ngValue]="country.cCode">
                  {{ country.cName | translate }}
                </option>
              }
            </select>
          </div>
          <div class="half-block">
            <label class="header-label" id="airportlabel" for="airport" i18n="@@pnlSearchAirport"
              >Airport</label
            >
            <i class="ico-flight combo-box-icon" aria-hidden="true"></i>
            <div class="flex-row-container">
              <input
                #inputAirport="ngbTypeahead"
                autocomplete="off"
                type="text"
                id="airport"
                i18n-placeholder
                placeholder="Enter an airport"
                name="travellingFrom"
                [inputFormatter]="formatAirports"
                [ngbTypeahead]="getAirports"
                [(ngModel)]="searchParameters.locationCode"
                [ngClass]="{
                  'error-box': searchParameters.validationMessages?.includes(
                    'You must select airport first.'
                  )
                }"
                [resultTemplate]="rt"
                (focus)="airportsFocus$.next($event.target.value)"
                (click)="$event.target.select(); airportsClick$.next($event.target.value)"
                appSelect
                aria-labelledby="airportlabel"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
              @if (loadingAirports) {
                <i class="button_spinner input-loading-spinner-left"></i>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="half-block right-block">
        <div class="half-container">
          <div class="half-block">
            <label
              class="header-label"
              id="terminallabel"
              i18n="@@pnlSearchTerminal"
              for="pnl_terminal"
              >Terminal</label
            >
            @if (data.terminals.length === 0) {
              <p i18n="@@ParkingSearchSelectAirportFirst">Select airport first</p>
            }
            <select
              [(ngModel)]="searchParameters.terminal"
              appSelect
              class="select-box-right terminals"
              id="lounge-select-terminal"
            >
              @for (terminal of data.terminals; track terminal) {
                <option [ngValue]="terminal.value">
                  {{ terminal.key | translate }}
                </option>
              }
            </select>
          </div>
          <div class="half-block">
            <label class="header-label" for="Flightnumberlabel" i18n="@@ParkingSearchFlightNumber"
              >Flight number</label
            >
            <input
              appInput
              [noIcon]="true"
              i18n-placeholder
              placeholder="Enter flight number"
              [(ngModel)]="searchParameters.flightNumber"
              id="Flightnumberlabel"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="half-container">
      <div class="half-block">
        <div
          class="flex-row-container"
          [ngClass]="{
            'error-box': searchParameters.validationMessages?.includes(
              'Outward journey cannot be in the past.'
            )
          }"
        >
          <ngbd-datepicker-i18n>
            <div class="flex-column-container combo-box-left">
              <label
                class="header-label date-label"
                id="outwardjourney"
                i18n="@@taxiSearchDateAndTime"
                for="lounge-date"
                >Date (DD/MM/YYYY)</label
              >
              <i class="ico-calendar combo-box-icon" aria-hidden="true" style="cursor: pointer"></i>
              <app-datepicker
                [minDate]="searchParameters.min_date"
                [startDate]="searchParameters.date"
                [model]="searchParameters.date"
                [class]="'combo-box'"
                [componentId]="'lounge-date'"
                (newDate)="searchParameters.date = $event"
              >
              </app-datepicker>
            </div>
            <div class="flex-column-container select-box-right">
              <label
                id="pnl-search-outward-time"
                class="header-label"
                i18n="@@SearchTaxiPickupTime"
                for="pnl_outward_time"
                >Time</label
              >
              <i class="ico-clock select-box-icon" aria-hidden="true"></i>
              <select
                appSelect
                [(ngModel)]="searchParameters.time"
                aria-labelledby="pnl-search-outward-time"
                id="pnl_outward_time"
              >
                @for (time of timesArray; track time) {
                  <option [ngValue]="time">{{ time }}</option>
                }
              </select>
            </div>
          </ngbd-datepicker-i18n>
        </div>
      </div>
    </div>
  </div>
}
<app-lounge-loading-screen></app-lounge-loading-screen>
